import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Tabs, Tab, Button, Offcanvas, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import auths from "../../actions/auth";


export default function ProfilePassword() {
  const formRef = useRef();
  const navigate = useNavigate();
  const [confirmPassType, setConfirmPassType] = useState(true);
  const [passType, setPassType] = useState(true);
  const [cpassType, setCpassType] = useState(true);
  const [form, setForm] = useState({
      current_password: "",
      password: "",
      password_confirmation: ""
   });

   useEffect(() => {
  },[]);

   const handleSubmit = (e) => {
      e.preventDefault();
      auths.actions.put_password(form).then((res) => {
         toast.success(res.message);
         navigate('/profile')
      }).catch((err) => {
         toast.error(err.message);
      });
   }


   
  return (
   <div className="bg-light vh-100">
       <div className="fixed-top header bg-light">
         <div className="text-center fw-semibold">
            Ubah Kata Sandi
         </div>
         <Button className="btn btn-icon btn-success btn-sm btn-radius btn-nav-back" onClick={() => navigate(-1)}>
               <i className="ph-arrow-left text-light"></i>
         </Button>
      </div>

      <Form onSubmit={(e) => handleSubmit(e)} ref={formRef}>  
         <div className="px-4 content-height pt-5 mt-5 bg-light">
            <Form.Group className="mb-3" controlId="formBasicPassword">
               <Form.Label className="mb-2">Kata Sandi Lama*</Form.Label>
               <div className="position-relative">
                  <Form.Control type={confirmPassType ? 'password' : 'text'} placeholder="Kata sandi" onChange={(e) => setForm({...form, ...{current_password: e.target.value}})}/>
                  <Form.Text className="input-icon" onClick={()=>setConfirmPassType(!confirmPassType)}>
                     {confirmPassType ?
                        <i className="ph-eye text-success-bold fw-bold"></i> :
                        <i className="ph-eye-slash text-success-bold fw-bold"></i>
                     }
                  </Form.Text>
               </div>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
               <Form.Label className="mb-2">Kata Sandi Baru*</Form.Label>
               <div className="position-relative">
                  <Form.Control type={passType ? 'password' : 'text'} placeholder="Kata sandi" onChange={(e) => setForm({...form, ...{password: e.target.value}})}/>
                  <Form.Text className="input-icon" onClick={()=>setPassType(!passType)}>
                     {passType ?
                        <i className="ph-eye text-success-bold fw-bold"></i> :
                        <i className="ph-eye-slash text-success-bold fw-bold"></i>
                     }
                  </Form.Text>
               </div>
               { form.password.length < 5 && form.password.length ?
                  <small className="text-danger">Password minimal 5 karakter</small> : null
               }
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPasswordConfirm">
               <Form.Label className="mb-2">Ulangi Kata Sandi*</Form.Label>
               <div className="position-relative">
                  <Form.Control 
                     type={cpassType ? 'password' : 'text'} 
                     placeholder="Ulangi kata sandi" 
                     onChange={(e) => setForm({...form, ...{password_confirmation: e.target.value}})}
                  />
                  <Form.Text className="input-icon" onClick={()=>setCpassType(!cpassType)}>
                     {cpassType ?
                        <i className="ph-eye text-success-bold fw-bold"></i> :
                        <i className="ph-eye-slash text-success-bold fw-bold"></i>
                     }
                  </Form.Text>
               </div>
               { form.password_confirmation.length && form.password_confirmation !== form.password ?
                  <small className="text-danger">Password tidak sesuai</small> : null
               }
            </Form.Group>
         </div>

         <div className="btn-fixed-btm">
            <div className="d-flex justify-content-between align-items-center w-100 px-4">
               <Button type="button" className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity" onClick={() => navigate('/profile')}>
                  Batalkan
               </Button>
               <Button type="submit" className="rounded-pill py-2 w-50" variant="success">
                  Simpan
               </Button>
            </div>
         </div>
      </Form>
   </div>
  );
}